import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Trash2 } from "lucide-react";
import useSeo from "../hooks/useSeo";
import usePromo from "../hooks/usePromo";
import CartItem from "../components/cart/CartItem";
import OrderSummary from "../components/cart/OrderSummary";
import EmptyState from "../components/common/EmptyState";
import { useStore } from "../context/StoreProvider";

const Cart = () => {
  const { cart, cartCount, subtotal, clearCart } = useStore();
  const promo = usePromo(subtotal);

  useSeo({ title: "Cart", description: "Review your 9'One Store cart.", path: "/cart" });

  if (cart.length === 0) {
    return (
      <div className="container-9one">
        <EmptyState
          icon={ShoppingBag}
          title="Your cart is empty"
          message="Looks like you haven't added anything yet."
          ctaLabel="Shop Now"
          ctaTo="/shop"
          testId="cart-page-empty"
        />
      </div>
    );
  }

  return (
    <div className="container-9one py-12 animate-fade-in">
      <div className="mb-8 flex items-end justify-between">
        <h1 className="font-display text-5xl uppercase tracking-tight sm:text-6xl">
          Cart <span className="text-brand-dark">({cartCount})</span>
        </h1>
        <button
          onClick={clearCart}
          className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-ink/50 hover:text-ink"
          data-testid="clear-cart-btn"
        >
          <Trash2 size={14} /> Empty Cart
        </button>
      </div>

      <div className="grid gap-10 lg:grid-cols-3">
        <div className="divide-y divide-ink/10 border-t border-ink/10 lg:col-span-2">
          {cart.map((item) => (
            <CartItem key={item.lineId} item={item} />
          ))}
        </div>

        <div className="lg:col-span-1">
          <OrderSummary
            subtotal={subtotal}
            discount={promo.discount}
            total={promo.total}
            appliedPromo={promo.appliedPromo}
            promoInput={promo.promoInput}
            setPromoInput={promo.setPromoInput}
            onApplyPromo={promo.applyPromo}
            onRemovePromo={promo.removePromo}
            promoError={promo.promoError}
          >
            <Link to="/checkout" className="btn-solid w-full" data-testid="cart-proceed-btn">
              Proceed to Order
            </Link>
            <Link to="/shop" className="btn-outline mt-3 w-full">
              Continue Shopping
            </Link>
          </OrderSummary>
        </div>
      </div>
    </div>
  );
};

export default Cart;
